import { render, staticRenderFns } from "./ServersList.vue?vue&type=template&id=16df0772"
import script from "./ServersList.vue?vue&type=script&lang=js"
export * from "./ServersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports